var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCars2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.374 8.68295L9.54297 6.32872H12.3332L11.6356 2.23064L14.949 3.62572L15.5593 0.312378L17.4776 2.66661L20.2678 0.573948L19.2214 3.45135L22.8836 4.14888L20.1806 5.10802L17.7476 7.09754L16.6056 9.46769C16.6928 9.55488 12.7691 8.15979 11.374 8.68295Z",
    fill: "#02006B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7552 18.4488L30.3819 18.7976V20.803L33.5209 21.0646L34.044 14.1763L32.9105 11.7349L31.9514 8.50875C31.5154 7.11366 30.2947 6.06734 28.8996 5.98015L24.8015 5.71858L25.4119 5.80575L21.3138 5.54418C19.8315 5.45699 18.5236 6.24172 17.9132 7.54962L16.5181 10.6014L15.0359 12.7812L14.5127 19.6695L17.6517 19.9311L17.9132 17.9257L24.5399 18.536",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1666 19.9312L30.3818 19.844V20.8031H31.1666V19.9312Z",
    fill: "#E6F0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7552 18.4488L30.3819 18.7976V20.803L33.5209 21.0646L34.044 14.1763L32.9105 11.7349L31.9514 8.50875C31.5154 7.11366 30.2947 6.06734 28.8996 5.98015L24.8015 5.71858L25.4119 5.80575L21.3138 5.54418C19.8315 5.45699 18.5236 6.24172 17.9132 7.54962L16.5181 10.6014L15.0359 12.7812L14.5127 19.6695L17.6517 19.9311L17.9132 17.9257L24.5399 18.536",
    stroke: "#AA023F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2262 13.3011L17.1826 12.1676",
    stroke: "#AA023F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7669 15.413L28.641 15.9106",
    stroke: "#AA023F",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1692 10.5143L13.9894 10.1655C13.7278 10.1655 13.6406 9.90391 13.6406 9.72952L13.815 8.68322C13.815 8.42164 14.0766 8.24726 14.3382 8.33445L15.9077 8.59602C16.1692 8.68321 16.3436 8.9448 16.3436 9.20638L16.1692 10.5143Z",
    fill: "#AA023F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9111 11.735H35.091C35.3525 11.735 35.5269 11.5607 35.5269 11.2991V10.2527C35.5269 9.99116 35.3525 9.81677 35.091 9.81677H33.5215C33.2599 9.81677 32.9983 10.0784 32.9983 10.3399L32.9111 11.735Z",
    fill: "#AA023F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1753 17.4027C18.1753 17.4027 15.298 17.1411 14.6876 16.8795C14.0773 16.7051 14.2516 19.7569 14.5132 19.5825C14.7748 19.4081 17.6522 19.8441 17.6522 19.8441L18.1753 17.4027Z",
    fill: "#AA023F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1768 18.3536C30.1768 18.3536 32.9701 18.4383 33.6473 18.3536C34.3245 18.269 33.6473 21.147 33.478 20.9777C33.3087 20.8084 30.4307 20.7238 30.4307 20.7238L30.1768 18.3536Z",
    fill: "#AA023F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5642 14.6995L15.21 14.5251L15.3843 12.7812L17.7386 12.9556C18.1745 12.9556 18.6105 13.3916 18.5233 13.9148C18.4361 14.3507 18.0002 14.6995 17.5642 14.6995Z",
    fill: "#AA023F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 21.2384L17.2156 20.5409L17.4772 22.3719L20.4418 22.1104L19.9186 15.6581L18.5235 13.5654L17.2156 10.688C16.6053 9.46731 15.2973 8.68259 13.9894 8.76978L10.0657 9.11855L10.6761 9.03135L6.75239 9.38012C5.3573 9.46731 4.22378 10.4265 3.87501 11.8215L3.09027 14.8733L2.04395 17.1403L2.56711 23.5927L5.53168 23.3311L5.44449 21.4128L11.6352 20.9769",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1744 21.5L17.3896 21.5872L17.564 22.3719H18.2616L18.1744 21.5Z",
    fill: "#E6F0FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 21.2384L17.2156 20.5409L17.4772 22.3719L20.4418 22.1104L19.9186 15.6581L18.5235 13.5654L17.2156 10.688C16.6053 9.46731 15.2973 8.68259 13.9894 8.76978L10.0657 9.11855L10.6761 9.03135L6.75239 9.38012C5.3573 9.46731 4.22378 10.4265 3.87501 11.8215L3.09027 14.8733L2.04395 17.1403L2.56711 23.5927L5.53168 23.3311L5.44449 21.4128L11.6352 20.9769",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 21.2384L17.2156 20.5409L17.4772 22.3719L20.4418 22.1104L19.9186 15.6581L18.5235 13.5654L17.2156 10.688C16.6053 9.46731 15.2973 8.68259 13.9894 8.76978L10.0657 9.11855L10.6761 9.03135L6.75239 9.38012C5.3573 9.46731 4.22378 10.4265 3.87501 11.8215L3.09027 14.8733L2.04395 17.1403L2.56711 23.5927L5.53168 23.3311L5.44449 21.4128L11.6352 20.9769",
    stroke: "#AA023F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2178 14.6261L2.53027 16.199",
    stroke: "#AA023F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82883 14.9604H0.823383C0.648996 14.9604 0.474609 14.786 0.474609 14.6117V13.6525C0.474609 13.3909 0.648996 13.2166 0.910577 13.2166H2.39286C2.65444 13.2166 2.91603 13.3909 2.91603 13.7397L2.82883 14.9604Z",
    fill: "#AA023F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6112 13.5655L20.6166 13.2167C20.791 13.2167 20.9654 12.9552 20.9654 12.7808L20.791 11.8217C20.791 11.5601 20.5294 11.3857 20.2679 11.4729L18.7856 11.7345C18.524 11.8217 18.3496 11.9961 18.3496 12.2576L18.6112 13.5655Z",
    fill: "#AA023F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61907 21.064C5.61907 21.064 2.91608 21.2384 2.21853 21.1512C1.60818 21.064 2.21853 23.8542 2.48011 23.6798C2.74169 23.5054 5.44469 23.4182 5.44469 23.4182L5.61907 21.064Z",
    fill: "#AA023F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8672 20.1051C16.8672 20.1051 19.5702 19.7564 20.1805 19.582C20.7909 19.4076 20.6165 22.285 20.4421 22.1106C20.2677 21.9362 17.4775 22.3721 17.4775 22.3721L16.8672 20.1051Z",
    fill: "#AA023F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCars2);
export default __webpack_public_path__ + "static/media/Cars2.cb688acd8646baaacee48abc91a006f5.svg";
export { ForwardRef as ReactComponent };